module.exports = __webpack_public_path__ + "static/img/hero-bg.a53bacbf.jpg";